import { schema } from 'normalizr'

import reservationUser from './reservationUser'

const reservation = new schema.Entity('reservations', {
  reservation_users: [reservationUser]
})

export default reservation
